// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wl_a bho_b","TwoDimsListFeature__item":"wl_b bho_ux","TwoDimsListFeature__item__text":"wl_c bho_un"};